import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowExpenseLarge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 8,
	viewBox: "0 0 25 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M24.8536 4.1514C25.0488 3.95614 25.0488 3.63956 24.8536 3.4443L21.6716 0.262318C21.4763 0.0670555 21.1597 0.0670555 20.9645 0.262318C20.7692 0.45758 20.7692 0.774162 20.9645 0.969424L23.7929 3.79785L20.9645 6.62628C20.7692 6.82154 20.7692 7.13812 20.9645 7.33339C21.1597 7.52865 21.4763 7.52865 21.6716 7.33339L24.8536 4.1514ZM0.5 4.29785H24.5V3.29785H0.5V4.29785Z",
		fill: "#D8D9DC"
	})
});
export default SvgArrowExpenseLarge;
